import * as React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../../../../common/modal';
import classnames from 'classnames';
import KonvaImage from '../KonvaImage';

const ImageModal = (props) => {
    return (
        <Modal
            isOpen={props.isOpen}
            className={classnames('modal-dialog--media-library')}
        >
            <ModalHeader onClose={props.onClose(null)}>
                <ModalTitle>Image viewer</ModalTitle>
            </ModalHeader>
            {props.cvEnabled ? (
                <React.Fragment>
                    <ModalBody style={{ textAlign: 'center' }}>
                        {props.question.options.length ? (
                            <p className="modal--helper">
                                Click{' '}
                                <span className="modal--helper-highlight">
                                    the label
                                </span>{' '}
                                to modify!
                            </p>
                        ) : (
                            <p>Click add new area to start!</p>
                        )}

                        <KonvaImage
                            imageURL={props.imageURL}
                            question={props.question}
                            handleOptionFields={props.handleOptionFields}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <button
                            className="btn btn--sm btn--green m-r-10"
                            onClick={props.addNewOption}
                        >
                            Add new area
                        </button>
                        <button
                            className="btn btn--sm btn--red m-r-10"
                            onClick={props.clearOptions}
                        >
                            Remove all
                        </button>
                        <button
                            className="btn btn--sm btn--transparent m-r-10"
                            onClick={props.onClose(null)}
                        >
                            Close
                        </button>
                    </ModalFooter>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <ModalBody>
                        <img
                            style={{ width: '100%' }}
                            className=""
                            src={props.imageURL}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <button
                            className="btn btn--sm btn--transparent m-r-10"
                            onClick={props.onClose(null)}
                        >
                            Close
                        </button>
                    </ModalFooter>
                </React.Fragment>
            )}
        </Modal>
    );
};

export default ImageModal;
